var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.165039,
    width: 20,
    height: 20.6701,
    rx: 6,
    fill: "#E8F0F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0262 13.8351C9.91652 13.8357 9.80781 13.8147 9.70627 13.7733C9.60474 13.7318 9.5124 13.6707 9.43453 13.5934L4.43453 8.59345C4.27761 8.43653 4.18945 8.2237 4.18945 8.00178C4.18945 7.77986 4.27761 7.56704 4.43453 7.41012C4.59145 7.2532 4.80428 7.16504 5.0262 7.16504C5.24811 7.16504 5.46094 7.2532 5.61786 7.41012L10.0262 11.8268L14.4345 7.41845C14.5939 7.28193 14.799 7.21059 15.0087 7.21869C15.2185 7.22679 15.4174 7.31373 15.5658 7.46215C15.7142 7.61056 15.8012 7.80951 15.8093 8.01924C15.8174 8.22897 15.7461 8.43403 15.6095 8.59345L10.6095 13.5934C10.4543 13.7474 10.2448 13.8342 10.0262 13.8351Z",
    fill: "#0069AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.cb1a6cde54f6ca7a61eb26482af07c1b.svg";
export { ForwardRef as ReactComponent };